<script>
import HeaderTab from '@/components/customer/HeaderTab'

export default {
  name: 'NoticeView',
  components: {
    HeaderTab
  }
}
</script>

<template>
  <div class="wrap">
    <div class="cs-body">
      <HeaderTab />
      <RouterView
        name="customerContent"
        :key="`customer_${$route.name}`"
      />
    </div>
  </div>
</template>
